import {AcceptableFulfillmentDate} from "@Common/logic/future-fulfillment/acceptable-fulfillment-date";
import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";
import {Load}                      from "@Common/react/load";
import {addDate, ge, today}        from "@Common/utils/date-object";
import {parseDateFormat}           from "@Common/utils/date/parse-date-format";

import {DateModal} from "../../../../common/date-modal/date-modal";

export const RescheduleModal = ({onClick=undefined, next: rootNext,}) => cs(
    consumeContext("apis"),
    consumeContext("systemConstants"),
    ["holidays", ({apis}, next) => Load({
        fetch: () => apis.next.getHolidays(),
        next,
    })],
    ({holidays, systemConstants}) => {
        const minDate = addDate(today(), +(systemConstants.value?.MIN_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??2));
        return DateModal({
            getTitle: () => "Select New Fulfillment Date",
            className: "date-reschedule",
            minDate,
            xdQaName: "Date Reschedule",
            onClick,
            dateFormat: parseDateFormat("yyyy-mm-dd"),
            isDateDisabled: (() => {
                const isAcceptableDate = AcceptableFulfillmentDate({holidays});
                return ({d, maxDate}) => {
                    if (!isAcceptableDate(d)) {
                        return true;
                    }

                    if (
                        !ge(d, minDate) ||
                        !ge(maxDate, d)
                    ) {
                        return true;
                    }
                };
            })(),
            next: rootNext,
        });
    }
)